@if (pageLoaded()) {
<div class="form buyer" style="transition: all 1s ease-in-out; margin: auto;" [style]="(!firstLoadPriceHistory())?'opacity: 0':''">
    <div class="">
        <div class="top-info" style="margin-bottom: 0;" #body>
            <div class="d-flex">
                <div class="provider-logo">
                    @if (supplierLogoUrl()!=null && supplierLogoUrl()!='') {
                    <img [src]="supplierLogoUrl()" (error)="supplierLogoUrl.set(null)" style="width: 35px; height: auto; margin-right: 5px;" />
                    }
                </div>
                <div class="provider-text auto">
                    @if (currentCost().isRate) {
                    <div>
                        <a (click)="changeCurrentElectricityPlan()" [style]="'color: #3c78d8'">
                            {{currentCost().supplierName}} &#64; {{currentCost().price | currency:'USD':'symbol':'1.3-3'}}/kWh (Update)
                        </a>
                    </div>
                    @if (isOnUtilityOnly()) {
                    <div class="mt-5">
                        {{currentCost().termFrom | date:'MMM yyyy'}} -
                        {{currentCost().rateEnd | date:'MMM yyyy'}} Meter Read *
                        <div class="f13">* You can switch your price plan at any time</div>
                    </div>
                    }
                    @if (!isOnUtilityOnly()) {
                    <div>
                        <a (click)="changeCurrentElectricityPlan()" [style]="'color: #3c78d8'">
                            {{currentCost().termFrom | date:'MMM yyyy'}} -
                            @if (currentCost().termTo!=null) {
                            {{currentCost().termTo | date:'MMM yyyy'}} Meter Read
                            }
                            @if (currentCost().termTo==null && currentCost().rateEnd!=null) {
                            {{currentCost().rateEnd | date:'MMM yyyy'}} Meter Read
                            }
                        </a>
                    </div>
                    }
                    }
                    @if (!currentCost().isRate) {
                    <div><a [routerLink]="((currentCost().isKilowantContract)?'/view-priceplan/'+currentCost().contractId:'/view-existing-priceplan/'+currentCost().contractId)" style="color:#3c78d8">{{currentCost().supplierName}} &#64; {{currentCost().price | currency:'USD':'symbol':'1.3-3'}}/kWh</a></div>
                    }
                    <div>
                        @if (!currentCost().isRate) {
                        @if (currentCost().termTo!=null) {
                        {{currentCost().termFrom | date:'MMM yyyy'}} -
                        {{currentCost().termTo | date:'MMM yyyy'}} Meter Read
                        }
                        @if (currentCost().termTo==null) {
                        {{currentCost().termFrom | date:'MMM yyyy'}} forward
                        }
                        }
                    </div>
                </div>
                <div>
                    <a (click)="changeViewPriceHistory()" [style]="(currentCost().isRate)?'':'margin-right: 30px;'" class="link" [class]="(viewPriceHistory())?'i-close':'i-view'">@if (viewPriceHistory()) { <div class="line1"><div class="line2"></div></div> }</a>
                </div>
            </div>
        </div>
        @if (priceHistoryLoaded()) {
        <div class="price-history-back" [class]="(firstLoadPriceHistory())?'step-inactive-body':''" [style]="(viewPriceHistory())?'height: '+historyChart.offsetHeight+'px;':'height: 0'">
            <div class="body pt-10" #historyChart>
                @if (!currentCost().isRate && (currentCost().saveVsEnergy>0 || currentCost().saveVsEnergyInUSD>0 || currentCost().saveVsCommunity>0 || currentCost().saveVsCommunityInUSD>0)) {
                <div class="price-info chat-info-shadow selected button mt-10 mb-20" [attr.style]="'background-color:'+((!currentCost().isKilowantContract)?'#ff8181; color: #fff;':getKilowantColor())">
                    @if (currentCost().termFrom!=null && currentCost().termTo!>currentDate.toJSDate()) {
                    You are projected to save
                    }
                    @if (currentCost().termFrom==null || currentCost().termTo!<=currentDate.toJSDate()) {
                    You have saved
                    }
                    @if (currentCost().saveVsEnergyInUSD>0) {
                    ${{currentCost().saveVsEnergyInUSD | number:'':'en'}} ({{currentCost().saveVsEnergy}}%) vs. RI Energy Last Resort Service
                    }
                    @if (currentCost().saveVsEnergyInUSD<=0 && currentCost().saveVsEnergy>0) {
                    {{currentCost().saveVsEnergy}}% vs. RI Energy Last Resort Service
                    }
                    @if (currentCost().saveVsCommunity!=null && currentCost().saveVsCommunity>0 && account().isCommunity) {
                    and
                    @if (currentCost().saveVsCommunityInUSD>0) {
                    ${{currentCost().saveVsCommunityInUSD | number:'':'en'}} ({{currentCost().saveVsCommunity}}%) vs. NextEra Energy
                    }
                    @if (currentCost().saveVsCommunityInUSD<=0 && currentCost().saveVsCommunity>0) {
                    {{currentCost().saveVsCommunity}}% vs. NextEra Energy
                    }
                    }
                </div>
                }
                <div class="price-history owl-theme">
                    <kilowant-charts-home-accept-offer [view]="view()" [legend]="legend()" [legendTitle]="legendTitle()"
                                                       [legendPosition]="legendPosition()" [showGridLines]="true" [showDataLabel]="false"
                                                       [scheme]="colorScheme()" [showXAxisLabel]="showXAxisLabel()" [showYAxisLabel]="showYAxisLabel()"
                                                       [xAxis]="xAxis()" [yAxis]="true" [xAxisLabel]="xAxisLabel()" [yAxisLabel]="yAxisLabel()"
                                                       [groupPadding]="2" [barPadding]="1"
                                                       [prefix]="'current-cost-'+prefix()"
                                                       [results]="pagedRates()"
                                                       [shadow]="true"
                                                       [valLabel]="chartLineName()"
                                                       [utilityAverageRate]="utilityAverageForHistory()"
                                                       [communityAverageRate]="communityAverageForHistory()"
                                                       [averageLineValue]="(currentCost().isRate && startRates()==rates().length-ratesPerPage())?future_price():0"
                                                       [averageLineColor]="'#'+getColorBasedOnUtility()"
                                                       [valColor]="(!currentCost().isRate && !currentCost().isKilowantContract)?'#ff8181':getKilowantColor()"
                                                       [leftShift]="historyContractShiftsLeft()"
                                                       [rightShift]="historyContractShiftsRight()"
                                                       [selectedDatasets]="selectedDatasets()"
                                                       [hideRenewable]="true"
                                                       [showNormalChatout]="false"
                                                       [tooltipDisabled]="true"
                                                       [utilityWarningDate]="latestUtilityDate()"
                                                       [communityWarningDate]="latestCommunityDate()">
                    </kilowant-charts-home-accept-offer>
                    <div class="owl-nav">
                        @if ((startRates()!=0)) {
                        <div class="owl-prev" (click)="historyLeft()"></div>
                        }
                        @if ((startRates()<rates().length-ratesPerPage())) {
                            <div class="owl-next" (click)="historyRight()"></div>
                        }
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>
}
